module.exports = __webpack_public_path__ + "img/social-links.deef68e6.png";